import { OrderPayMoreSteps } from "pages/OrderOverview/utils/constants";
import { useSelector } from "react-redux";
import { orderSelector } from "store/slices/order";

import { DOBAuth } from "./components/DOBAuth";
import { PayNow } from "./components/PayNow";

type OrderPayMoreProps = {
  variant: OrderPayMoreSteps;
};

export function PayMoreSection({ variant }: OrderPayMoreProps) {
  const { orderPayMoreStep } = useSelector(orderSelector);

  switch (orderPayMoreStep) {
    case OrderPayMoreSteps.PAY_MORE:
      return <PayNow />;

    default:
      return <DOBAuth {...{ variant }} />;
  }
}
